<div ngbDropdown autoClose="outside" (openChange)="emit(dropdown.isOpen())" class="filter-dropdown">
    <app-tooltip [dynamic]="false" class="display-inline-flex" message="Filter">
        <button [attr.data-cy]="getCypressTagElement('button')" [ngClass]="getCssButton()"
                class="filter filter-icon iwp-icon-gen_filter"
                ngbDropdownToggle
                tabIndex="-1"
                type="button"></button>
    </app-tooltip>

    <div ngbDropdownMenu class="filter-menu" >
         <div class="filter-all">
            <app-input-text #searchInput
                            hasSearchIcon="true"
                            [hasLabel]="false"
                            [baseCypressTag]="getCypressTag()"
                            [placeholder]="placeHolder"
                            [alternateBackground]="true"
                            (inputValueChange)="onValueChanges($event)"
                            (keydown.enter)="closeAndSearch()"></app-input-text>
         </div>
         <app-filter-footer
                (applyClick)="closeAndSearch()"
                (clearClick)="clear()"
                [filterName]="filterName"></app-filter-footer>
    </div>
</div>
